import jwt_decode from "jwt-decode";
export const userType = () => {
  const token = localStorage.getItem("utoken");
  let isSeeker = false,
    isGiver = false;
  if (token) {
    var decoded = jwt_decode(token);
    if (decoded.user_type === "seeker") {
      isSeeker = true;
    } else if (decoded.user_type === "giver") {
      isGiver = true;
    } else if (decoded.user_type === "both") {
      isGiver = true;
      isSeeker = true;
    }
  }
  return { isSeeker, isGiver };
};
